import { DateInput, type DateInputProps } from "@guestpilot/ui-kit";
import { useI18n } from "../i18n";

/** Date field written and picked in the language of the app (the browser's date input follows the browser's language, not Teams'). */
export function DateField(
  props: Omit<DateInputProps, "locale" | "openLabel" | "previousLabel" | "nextLabel">,
) {
  const { t, locale } = useI18n();
  return (
    <DateInput
      {...props}
      locale={locale}
      openLabel={t("ui:date.open")}
      previousLabel={t("ui:date.previous")}
      nextLabel={t("ui:date.next")}
    />
  );
}
